class DetailsDisclosure extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['details', 'summary']
  }

  setupListeners () {
    super.setupListeners()

    this.close = this.close.bind(this)

    this.onFocusOut = this.onFocusOut.bind(this)
    this.listeners.add(this.els.details.element, 'focusout', this.onFocusOut)

    for (const trigger of this.externalEls.trigger.elements) {
      this.listeners.add(trigger, 'click', this.toggle)
    }
  }

  onFocusOut () {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  close () {
    this.els.details.element.removeAttribute('open')
    this.els.summary.element.setAttribute('aria-expanded', 'false')
  }

  toggle () {
    this.els.details.element.toggleAttribute('open')
    this.els.summary.element.setAttribute('aria-expanded', this.els.details.element.open)
  }
}

customElements.define('details-disclosure', DetailsDisclosure)

window.BAO.DetailsDisclosure = DetailsDisclosure
